import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import ReactGoogleAutocomplete from "react-google-autocomplete";
import { Dialog, Switch, Transition } from "@headlessui/react";
import Button from "../../VibehutUI/Button";
import { StoreContext } from "../../Context/StoreContext";
import { createEvent, getRoomEvents } from "../../actions/eventActions";
import Loader from "../../VibehutUI/Loader";
import BannerPicker from "../rooms/BannerPicker";
import Back from "../../VibehutUI/Icons/Back";
import Close from "../../VibehutUI/Icons/Close";
import moment from "moment";
import momenttimezone from "moment-timezone";
import {
  getRandomPicture,
  getRoomSubscribers,
} from "../../services/rooomService";
import SelectBox from "../../VibehutUI/SelectBox";
import { uploadMedia } from "../../utils/uploadMedia";
import MultiSelectBox from "../../VibehutUI/MultiSelectBox";
import { handleCurrencyInputChange } from "../../utils/utils";
import CurrencyInput from "react-currency-input-field";
import VisEye from "../../VibehutUI/Icons/VisEye";
import HidEye from "../../VibehutUI/Icons/HidEye";
import LimitedTextarea from "../../VibehutUI/LimitedTextarea";
import { eventModalTab } from "../../constants";
import InviteSearchBar from "../../VibehutUI/InviteUserModel/InviteSearchBar";
import SendInvite from "../../VibehutUI/InviteUserModel/SendInvite";
import useDebounce from "../../hooks/useDebounce";
import { searchVibhutAndDesoUsers } from "../../services/userService";
import UserCardSkeleton from "../../VibehutUI/Skeletons/UserCardSkeleton";

const options = [
  { label: "Daily", value: "daily" },
  { label: "Alternate", value: "alternate" },
  { label: "Weekly", value: "weekly" },
  { label: "Weekday", value: "weekday" },
  { label: "Month", value: "monthly" },
];
const WeekdayOptions = [
  { label: "Monday", value: "mon" },
  { label: "Tuesday", value: "tue" },
  { label: "Wednesday", value: "wed" },
  { label: "Thursday ", value: "thurs" },
  { label: "Friday ", value: "fri" },
  { label: "Saturday ", value: "sat" },
  { label: "Sunday ", value: "sun" },
];

const InviteSection = ({
  isOpen,
  roomId,
  invitedUsers,
  setInvitedUsers,
  invitationMsg,
  setInvitationMsg,
}) => {
  const { state } = useContext(StoreContext);
  const { auth } = state;
  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [subscribers, setSubscribers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 1000);

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      setIsSearching(true);
      setSearchResults([]);
      searchVibhutAndDesoUsers(searchTerm)
        .then((response) => {
          const users = response.data.users;
          const filterUsers = users.filter(
            (user) =>
              user._id !== auth.user._id &&
              (user.role === "user" || user.role === "admin"),
          );
          setSearchResults(filterUsers);
        })
        .catch(console.log)
        .finally(() => {
          setIsSearching(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm]);

  useEffect(() => {
    if (isOpen) {
      getRoomSubscribers(auth.user.token, roomId)
        .then((response) => {
          const filterUsers = response.data.subsUserInfo.filter(
            (user) =>
              user._id !== auth.user._id &&
              (user.role === "user" || user.role === "admin"),
          );
          setSubscribers(filterUsers);
        })
        .catch(console.log);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <div className="transform transition-all">
      <div className="px-6 pt-3 custom-scrollbar">
        <div>
          <InviteSearchBar
            isLoading={isSearching}
            handleChange={handleChange}
            results={searchResults}
            value={searchTerm}
            setValue={setSearchTerm}
            invitedUsers={invitedUsers}
            setInvitedUsers={setInvitedUsers}
          />
        </div>

        {searchTerm.trim().length === 0 && (
          <div>
            {subscribers.length === 0 ? (
              <div
                className="overflow-y-scroll  custom-scrollbar "
                style={{ maxHeight: "30vh" }}
              >
                <UserCardSkeleton />
              </div>
            ) : (
              <div className="overflow-y-scroll  custom-scrollbar my-3 max-h-[47vh]  md:max-h-[42vh]">
                {subscribers.length > 0 &&
                  subscribers.map((user, index) => (
                    <SendInvite
                      key={index}
                      user={user}
                      invitedUsers={invitedUsers}
                      setInvitedUsers={setInvitedUsers}
                    />
                  ))}
              </div>
            )}
          </div>
        )}
      </div>

      <div className="py-2 px-6 space-y-1">
        <p className="text-sm font-medium text-darkNight  dark:text-frescoWhite ">
          Invitation Message
        </p>
        <LimitedTextarea
          limit={2000}
          value={invitationMsg}
          rows={5}
          onChange={(text) => setInvitationMsg(text)}
          placeHolder="Leave a  Invitation message"
        />
      </div>
    </div>
  );
};

const EventSection = ({
  setIsOpen,
  roomId,
  roomCallMaxParticipants = 0,
  setCoverOpen,
  cover,
  coverLoading,
  coverFile,
  setCoverFile,
  eventData,
  setCover,
  invitedUsers,
  invitationMsg,
}) => {
  const { state, dispatch } = useContext(StoreContext);
  const coverImage = {
    urls: {
      raw: "https://images.unsplash.com/photo-1632633446780-a017032d265a?ixid=MnwyNjkwNTR8MHwxfHJhbmRvbXx8fHx8fHx8fDE2MzQ4NDA4NjM&ixlib=rb-1.2.1",
      full: "https://images.unsplash.com/photo-1632633446780-a017032d265a?crop=entropy&cs=srgb&fm=jpg&ixid=MnwyNjkwNTR8MHwxfHJhbmRvbXx8fHx8fHx8fDE2MzQ4NDA4NjM&ixlib=rb-1.2.1&q=85",
      regular:
        "https://images.unsplash.com/photo-1632633446780-a017032d265a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNjkwNTR8MHwxfHJhbmRvbXx8fHx8fHx8fDE2MzQ4NDA4NjM&ixlib=rb-1.2.1&q=80&w=1080",
      small:
        "https://images.unsplash.com/photo-1632633446780-a017032d265a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNjkwNTR8MHwxfHJhbmRvbXx8fHx8fHx8fDE2MzQ4NDA4NjM&ixlib=rb-1.2.1&q=80&w=400",
      thumb:
        "https://images.unsplash.com/photo-1632633446780-a017032d265a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNjkwNTR8MHwxfHJhbmRvbXx8fHx8fHx8fDE2MzQ4NDA4NjM&ixlib=rb-1.2.1&q=80&w=200",
    },
  };

  const {
    auth: { user },
    event: { isFetching },
    eventCreation,
  } = state;

  const [visError, setVisError] = useState(false);
  const [startDateErr, setStartDateError] = useState(false);
  const [isRecurrEvent, setIsRecurrEvent] = useState(false);
  const [isExternalEvent, setIsExternalEvent] = useState(false);
  const [isRequireApproval, setIsRequireApproval] = useState(false);
  const [isPaidEvent, setIsPaidEvent] = useState(false);
  const [amount, setAmount] = useState(0);
  const [isMaxRsvp, setIsMaxRsvp] = useState(
    roomCallMaxParticipants > 0 ? true : false,
  );
  const [maxRsvp, setMaxRsvp] = useState(roomCallMaxParticipants);
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [selectedWeekOption, setSelectedWeekOption] = useState([]);
  const [isPasswordProtected, setIsPasswordProtected] = useState(false);
  const [isPassVisible, setIsPassVisible] = useState(false);
  const [showPasswordErr, setShowPasswordErr] = useState(false);
  const [password, setPassword] = useState("");
  const [event, setEvent] = useState({
    title: "",
    startDate: "",
    endDate: "",
    description: "",
    link: "",
  });
  const [recurrEventDate, setRecurrEventDate] = useState("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [showPaymentErr, setShowPaymentErr] = useState("");
  const [showMaxRsvpErr, setShowMaxRsvpErr] = useState("");

  const [selectedLocation, setSelectedLocation] = useState({
    formatted_address: "",
    lat: "",
    lng: "",
  });

  const handleLocationChange = (e) => {
    setSelectedLocation({ formatted_address: e.target.value });
  };

  const handleChange = (e) => {
    setEvent({ ...event, [e.target.name]: e.target.value });
  };

  const handleDescriptionChange = (text) => {
    setEvent((prev) => ({ ...prev, description: text }));
  };

  const handleRecurrOptChange = (value) => {
    setSelectedOption(value);
  };

  const handleRecurrDateChange = (e) => {
    setRecurrEventDate(e.target.value);
  };

  const handleDateChange = (e) => {
    if (e.target.name === "startDate") {
      const endDate = new Date(e.target.value);
      endDate.setHours(endDate.getHours() + 1);
      setEvent({
        ...event,
        startDate: formatForDateInput(new Date(e.target.value)),
        endDate: formatForDateInput(endDate),
      });
      setStartDateError(false);
    } else {
      setVisError(false);
      setEvent({
        ...event,
        [e.target.name]: formatForDateInput(new Date(e.target.value)),
      });
    }
  };

  const handleCreateEvent = (media = undefined) => {
    const startDate = new Date(event.startDate);
    const endDate = new Date(event.endDate);
    if (isRecurrEvent && checkDates()) {
      setStartDateError(true);
      return;
    }
    if (
      (Number.isNaN(parseInt(amount)) || Number(amount) === 0) &&
      isPaidEvent
    ) {
      if (Number(amount) === 0) {
        setShowPaymentErr(" Minimum amount to charge is $1.00");
        setTimeout(() => {
          setShowPaymentErr("");
        }, 5000);
        return;
      } else {
        setShowPaymentErr("Please enter a valid amount");
        setTimeout(() => {
          setShowPaymentErr("");
        }, 5000);
        return;
      }
    }
    if (
      (endDate.getDate() < startDate.getDate() &&
        endDate.getMonth <= startDate.getMonth()) ||
      (endDate.getDate() === startDate.getDate() &&
        endDate.getHours() < startDate.getHours()) ||
      (endDate.getDate() === startDate.getDate() &&
        endDate.getHours() === startDate.getHours() &&
        endDate.getMinutes() < startDate.getMinutes())
    ) {
      setVisError(true);
      return;
    }
    if (isMaxRsvp && !maxRsvp) {
      setShowMaxRsvpErr("Enter any valid number");
      return;
    }
    if (isMaxRsvp && Number(maxRsvp) <= 0) {
      setShowMaxRsvpErr("0 and negative values are not allowed");
      return;
    }
    const title = event.title;
    const description = event.description;
    const data = isRecurrEvent
      ? {
          title,
          description,
          startDate,
          endDate,
          isPaidEvent,
          price: amount,
          creatorTimeZone: momenttimezone.tz.guess(),
          cover: media?.url
            ? {
                urls: {
                  raw: media.url,
                  full: media.url,
                  regular: media.url,
                  small: media.url,
                  thumb: media.url,
                },
                source: "custom",
              }
            : cover,
          room: roomId,
          recurrDate: recurrEventDate,
          isRecurrEvent: isRecurrEvent,
          isPasswordProtected,
          isExternalEvent,
          ...(isExternalEvent && {
            location: selectedLocation || {},
            extLink: event.link,
          }),
          ...(password && { password: password }),
          ...(maxRsvp && isMaxRsvp && { maxRsvp: Number(maxRsvp) }),
          selectedOption: selectedOption.value,
          selectedWeekOption: selectedWeekOption.map(
            (options) => options.value,
          ),
          isRequireApproval,
          ...(invitedUsers?.length && {
            invitedUsers: invitedUsers,
            invitationMsg: invitationMsg,
          }),
        }
      : {
          title,
          description,
          startDate,
          endDate,
          isPaidEvent,
          price: amount,
          creatorTimeZone: momenttimezone.tz.guess(),
          cover: media?.url
            ? {
                urls: {
                  raw: media.url,
                  full: media.url,
                  regular: media.url,
                  small: media.url,
                  thumb: media.url,
                },
                source: "custom",
              }
            : cover,
          room: roomId,
          isPasswordProtected,
          isExternalEvent,
          ...(isExternalEvent && {
            location: selectedLocation || {},
            extLink: event.link,
          }),
          ...(password && { password: password }),
          ...(maxRsvp && isMaxRsvp && { maxRsvp: Number(maxRsvp) }),
          isRequireApproval,
          ...(invitedUsers?.length && {
            invitedUsers: invitedUsers,
            invitationMsg: invitationMsg,
          }),
        };

    createEvent(data, user.token, dispatch, isRecurrEvent).then(() => {
      if (isRecurrEvent) {
        getRoomEvents(user.token, dispatch, roomId, false, 0);
      }
      setIsOpen(false);
      setCover(coverImage);
      setEvent({
        title: "",
        description: "",
        startDate: "",
        endDate: "",
      });
      setRecurrEventDate();
      setSelectedOption(options[0]);
    });
  };

  const handleUploadAndCreateEvent = async () => {
    if (isPasswordProtected && password === "") {
      setShowPasswordErr(true);
      return;
    }
    if (coverFile) {
      await uploadMedia(
        coverFile,
        cover?.urls?.small,
        setIsImageUploading,
        setCover,
        setCoverFile,
        handleCreateEvent,
      );
    } else {
      await handleCreateEvent();
    }
  };

  const formatForDateInput = (date) => {
    return moment(date).format("YYYY-MM-DDTHH:mm");
  };

  const checkDates = () => {
    const startDate = moment(event.startDate);
    const endDate = moment(recurrEventDate);
    return startDate > endDate;
  };

  const handlePasswordChange = (e) => {
    if (e.target.value.length <= 16) {
      setPassword(e.target.value);
      setShowPasswordErr(false);
    }
  };

  const validateAndSetEventTime = () => {
    if (eventData && eventData.startDate) {
      const startDate = new Date(eventData.startDate);
      if (startDate > new Date()) {
        if (eventData.endDate) {
          const endDate = new Date(eventData.endDate);
          if (endDate > startDate) {
            setEvent((prev) => ({
              ...prev,
              startDate: formatForDateInput(startDate),
              endDate: formatForDateInput(endDate),
            }));
          } else {
            console.error("End date must be greater than start date");
          }
        } else {
          const oneHourLater = new Date(startDate.getTime() + 60 * 60 * 1000);
          setEvent((prev) => ({
            ...prev,
            startDate: formatForDateInput(startDate),
            endDate: formatForDateInput(oneHourLater),
          }));
        }
      } else {
        console.error("Start date must be greater than current time");
      }
    }
  };

  React.useEffect(() => {
    if (eventData) {
      setEvent({
        title: eventData.name,
        description: eventData.description,
      });
      setCover(eventData.cover);
      validateAndSetEventTime();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventData]);

  return (
    <div>
      <div>
        <div className="bg-white dark:bg-navyGray p-4 relative flex space-x-3">
          <div className="w-56">
            {(cover?.urls?.small || !!coverFile) && (
              <img
                alt="room"
                src={
                  coverFile
                    ? URL.createObjectURL(coverFile)
                    : cover?.urls?.small
                }
                className="rounded-xl object-cover w-full"
                loading="lazy"
              />
            )}
          </div>
          <div className="">
            <p className="text-base font-medium text-darkNight dark:text-frescoWhite">
              Event Cover
            </p>
            <p className="text-sm font-normal text-darkGray">
              This cover will appear as the event thumbnail.
            </p>
            {coverLoading ? (
              <div className="centerAbsolute mt-1 text-sm py-2 px-3 font-normal rounded-2xl">
                <Loader />
              </div>
            ) : (
              <div className="pt-2">
                <Button
                  onClick={() => setCoverOpen(true)}
                  size="vibhut-sm"
                  variant="vibhut-primary"
                >
                  Change
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className="px-4">
          <div>
            <p className="text-sm font-medium text-darkNight dark:text-frescoWhite">
              Event Title*
            </p>
            <input
              type="text"
              className="md:text-sm text-base border outline-none border-primaryGray py-2 px-4 rounded-xl my-1.5 w-full placeholder-notifyBg "
              value={event.title}
              onChange={handleChange}
              name="title"
              placeholder="E.g. Producivity Hacks"
            />
          </div>
          <div className="mt-3">
            <p className="text-sm font-medium text-darkNight dark:text-frescoWhite">
              Event Description
            </p>
            <LimitedTextarea
              limit={2000}
              value={event.description || ""}
              rows={5}
              placeHolder="E.g. Describe your event"
              name="description"
              onChange={handleDescriptionChange}
            />
          </div>
          <div className={`flex justify-between items-center py-1.5 pb-2`}>
            <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
              Require Approval to Join Event ?
            </p>

            <Switch
              checked={isRequireApproval}
              onChange={setIsRequireApproval}
              className={`${
                isRequireApproval ? "bg-primary" : "bg-gray-200"
              } relative inline-flex items-center  rounded-full h-31px w-51px float-right`}
            >
              <span
                className={`${
                  isRequireApproval ? "translate-x-6" : "translate-x-1"
                } inline-block w-27px h-27px transform bg-white shadow rounded-full duration-200`}
              />
            </Switch>
          </div>
          <div
            className={`flex justify-between items-center ${
              isExternalEvent ? "pt-1.5" : " py-1.5 pb-2"
            }`}
          >
            <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
              Is This External Event ?
            </p>

            <Switch
              checked={isExternalEvent}
              onChange={() => setIsExternalEvent(!isExternalEvent)}
              className={`${
                isExternalEvent ? "bg-primary" : "bg-gray-200"
              } relative inline-flex items-center  rounded-full h-31px w-51px float-right`}
            >
              <span
                className={`${
                  isExternalEvent ? "translate-x-6" : "translate-x-1"
                } inline-block w-27px h-27px transform bg-white shadow rounded-full duration-200`}
              />
            </Switch>
          </div>
          {isExternalEvent && (
            <>
              <ReactGoogleAutocomplete
                className="border outline-none border-primaryGray py-2 px-4 rounded-xl my-1 w-full placeholder-notifyBg text-sm"
                placeholder="Enter Location"
                debounce="1000"
                value={selectedLocation.formatted_address}
                onChange={handleLocationChange}
                onPlaceSelected={(place) => {
                  setSelectedLocation({
                    formatted_address: place.formatted_address || "",
                    lat: `${place.geometry?.location?.lat() || ""}`,
                    lng: `${place.geometry?.location?.lng() || ""}`,
                  });
                }}
              />
              <div className="pt-2">
                <p className="text-sm font-medium text-darkNight dark:text-frescoWhite">
                  External URL (Zoom, EventBrite)
                </p>
                <input
                  type="text"
                  className="border  outline-none border-primaryGray py-2 px-4 rounded-xl my-1 w-full placeholder-notifyBg text-sm"
                  value={event.link}
                  name="link"
                  onChange={handleChange}
                  placeholder="Any other url"
                />
              </div>
            </>
          )}

          <div
            className={`flex justify-between items-center ${
              isRecurrEvent ? " pt-1.5" : " py-1.5"
            }`}
          >
            <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
              Is This Recurring Event ?
            </p>

            <Switch
              checked={isRecurrEvent}
              onChange={() => setIsRecurrEvent(!isRecurrEvent)}
              className={`${
                isRecurrEvent ? "bg-primary" : "bg-gray-200"
              } relative inline-flex items-center  rounded-full h-31px w-51px float-right`}
            >
              <span
                className={`${
                  isRecurrEvent ? "translate-x-6" : "translate-x-1"
                } inline-block w-27px h-27px transform bg-white shadow rounded-full duration-200`}
              />
            </Switch>
          </div>
          {isRecurrEvent && (
            <div className="flex justify-between items-center py-1.5">
              <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
                Select Recurring Type
              </p>

              <SelectBox
                onChange={handleRecurrOptChange}
                selected={selectedOption}
                options={options}
              />
            </div>
          )}
          {isRecurrEvent && selectedOption.label === "Weekday" && (
            <div className="flex justify-between items-center py-1.5">
              <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
                Select Days of week
              </p>

              <MultiSelectBox
                selectedWeekOption={selectedWeekOption}
                setSelectedWeekOption={setSelectedWeekOption}
                WeekdayOptions={WeekdayOptions}
              />
            </div>
          )}
          {isRecurrEvent && (
            <>
              <div className="flex pt-1.5 justify-between items-center ">
                <div className=" w-2/3">
                  <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
                    End Recurring Date
                  </p>
                  <p className="font-normal text-sm text-darkGray">
                    When will the Recurring event End?
                  </p>
                </div>
                <div className="w-1/3">
                  <input
                    type="date"
                    className="text-sm border outline-none border-primaryGray py-2 px-2 rounded-xl my-1 w-full"
                    value={recurrEventDate}
                    onChange={handleRecurrDateChange}
                    name="startDate"
                    min={new Date().toISOString().slice(0, 16)}
                  />
                </div>
              </div>
              <div className="w-full border-b border-frescoWhite dark:border-matteGray py-1.5"></div>
            </>
          )}
          {eventCreation.hasAccess && (
            <>
              <div
                className={`flex justify-between items-center ${
                  isPaidEvent ? " pt-1.5" : " py-1.5"
                }`}
              >
                <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
                  Is Paid Event ?
                </p>

                <Switch
                  checked={isPaidEvent}
                  onChange={() => setIsPaidEvent(!isPaidEvent)}
                  className={`${
                    isPaidEvent ? "bg-primary" : "bg-gray-200"
                  } relative inline-flex items-center  rounded-full h-31px w-51px float-right`}
                >
                  <span
                    className={`${
                      isPaidEvent ? "translate-x-6" : "translate-x-1"
                    } inline-block w-27px h-27px transform bg-white shadow rounded-full duration-200`}
                  />
                </Switch>
              </div>
              {isPaidEvent && (
                <div className="flex flex-row justify-between w-full items-center py-1.5">
                  <div>
                    <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
                      Amount
                    </p>
                  </div>
                  <div>
                    <CurrencyInput
                      prefix="$"
                      name="currencyInput"
                      id="currencyInput"
                      data-number-to-fixed="2"
                      data-number-stepfactor="100"
                      value={amount}
                      placeholder="$0.00"
                      className="text-sm border outline-none border-primaryGray py-2 px-2 rounded-xl my-1 w-full"
                      onChange={(e) => {
                        handleCurrencyInputChange(e, setAmount);
                      }}
                      onBlur={() => setAmount(Number(amount).toFixed(2))}
                      allowDecimals
                      decimalsLimit="2"
                      decimalScale="2"
                      disableAbbreviations
                    />
                    {showPaymentErr && (
                      <p className={` text-xs text-cvRed`}>{showPaymentErr}</p>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
          <div
            className={`flex justify-between items-center ${
              isPasswordProtected ? " pt-1.5" : " py-1.5"
            }`}
          >
            <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
              Is This Password Protected Event ?
            </p>

            <Switch
              checked={isPasswordProtected}
              onChange={() => setIsPasswordProtected(!isPasswordProtected)}
              className={`${
                isPasswordProtected ? "bg-primary" : "bg-gray-200"
              } relative inline-flex items-center  rounded-full h-31px w-51px float-right`}
            >
              <span
                className={`${
                  isPasswordProtected ? "translate-x-6" : "translate-x-1"
                } inline-block w-27px h-27px transform bg-white shadow rounded-full duration-200`}
              />
            </Switch>
          </div>
          <div className={`${isPasswordProtected ? "" : "hidden"} `}>
            <div className="relative w-full">
              <input
                type={isPassVisible ? "text" : "password"}
                className={`text-sm border ${
                  showPasswordErr ? "border-red-500" : "border-primaryGray"
                } outline-none  py-2 px-4 rounded-xl my-1.5 w-full placeholder-notifyBg relative`}
                value={password}
                max={16}
                onChange={handlePasswordChange}
                placeholder="Password"
              />
              <span
                className="cursor-pointer absolute top-4 right-3 z-10"
                onClick={() => setIsPassVisible(!isPassVisible)}
              >
                {isPassVisible ? <VisEye /> : <HidEye />}
              </span>
            </div>
            {showPasswordErr ? (
              <p className={` text-xs text-cvRed`}>Password can't be empty</p>
            ) : null}

            <p className={` text-gray-400 text-xs`}>16 Characters max</p>
          </div>
          <>
            <div
              className={`flex justify-between items-center ${
                isMaxRsvp ? " pt-1.5" : " py-1.5"
              }`}
            >
              <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
                Max RSVP
              </p>

              <Switch
                checked={isMaxRsvp}
                onChange={() => setIsMaxRsvp(!isMaxRsvp)}
                className={`${
                  isMaxRsvp ? "bg-primary" : "bg-gray-200"
                } relative inline-flex items-center  rounded-full h-31px w-51px float-right`}
              >
                <span
                  className={`${
                    isMaxRsvp ? "translate-x-6" : "translate-x-1"
                  } inline-block w-27px h-27px transform bg-white shadow rounded-full duration-200`}
                />
              </Switch>
            </div>
            {isMaxRsvp && (
              <div className="flex flex-row justify-between w-full items-center py-1.5">
                <div>
                  <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
                    Total
                  </p>
                </div>
                <div>
                  <input
                    type="number"
                    className={` border ${
                      !showMaxRsvpErr ? "border-primaryGray" : "border-red-500"
                    } text-sm placeholder-gray-400  border  outline-none  py-2 px-2 rounded-xl my-1  w-54 `}
                    value={maxRsvp}
                    onChange={(e) => setMaxRsvp(e.target.value)}
                    name="endDate"
                    min={1}
                  />
                  {!!showMaxRsvpErr && (
                    <p className={` text-xs text-cvRed`}>{showMaxRsvpErr}</p>
                  )}
                </div>
              </div>
            )}
          </>
          <div className="flex pt-1.5 justify-between items-center ">
            <div className="">
              <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
                Start Time*
              </p>
              <p className="font-normal text-sm text-darkGray">
                When will the event begin?
              </p>
            </div>
            <div className="">
              <input
                type="datetime-local"
                className={`text-sm border ${
                  !startDateErr ? "border-primaryGray" : "border-red-500 "
                } outline-none border-primaryGray py-2 px-2 rounded-xl my-1 w-54`}
                value={event.startDate}
                onChange={handleDateChange}
                // pattern="[0-9]{2}-[0-9]{2}-[0-9]{4}T[0-9]{2}:[0-9]{2}"
                name="startDate"
                min={new Date().toISOString().slice(0, 16)}
              />
            </div>
          </div>
          {startDateErr && (
            <p className={` text-xs text-cvRed pt-2`}>
              * Start Date should be smaller then End Recurring Date
            </p>
          )}
          <div className="w-full  border-b border-frescoWhite dark:border-matteGray py-1.5"></div>
          <div className="flex justify-between items-center py-1.5  ">
            <div className="">
              <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
                End Time*
              </p>
              <p className="font-normal text-sm text-darkGray">
                When will it end?
              </p>
            </div>
            <div className="">
              <input
                type="datetime-local"
                className={` border ${
                  !visError ? "border-primaryGray" : "border-red-500"
                } text-sm placeholder-gray-400  border  outline-none  py-2 px-2 rounded-xl my-1  w-54 `}
                value={event.endDate}
                onChange={handleDateChange}
                name="endDate"
                min={formatForDateInput(event.startDate)}
              />
            </div>
          </div>
          {visError && (
            <p className={` text-xs text-cvRed`}>
              * End time should be greater then Start time
            </p>
          )}
        </div>
        <div className=" px-4 py-3 flex flex-row-reverse ">
          {isFetching || isImageUploading ? (
            <Loader />
          ) : event.title === "" ||
            !event.startDate ||
            (isRecurrEvent && !recurrEventDate) ||
            (selectedOption.label === "Weekday" &&
              selectedWeekOption.length === 0) ? (
            <Button
              size="vibhut-sm"
              variant="vibhut-primary-disable"
              disabled={true}
            >
              Submit
            </Button>
          ) : (
            <Button
              onClick={handleUploadAndCreateEvent}
              size="vibhut-sm"
              variant="vibhut-primary"
            >
              Submit
            </Button>
          )}
          <div className="mr-3">
            <Button
              size="vibhut-sm"
              variant="vibhut-secondary"
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default function CreateEvent({
  isOpen,
  setIsOpen,
  roomId,
  eventData,
  roomCallMaxParticipants = 0,
}) {
  const { state } = useContext(StoreContext);
  const coverImage = {
    urls: {
      raw: "https://images.unsplash.com/photo-1632633446780-a017032d265a?ixid=MnwyNjkwNTR8MHwxfHJhbmRvbXx8fHx8fHx8fDE2MzQ4NDA4NjM&ixlib=rb-1.2.1",
      full: "https://images.unsplash.com/photo-1632633446780-a017032d265a?crop=entropy&cs=srgb&fm=jpg&ixid=MnwyNjkwNTR8MHwxfHJhbmRvbXx8fHx8fHx8fDE2MzQ4NDA4NjM&ixlib=rb-1.2.1&q=85",
      regular:
        "https://images.unsplash.com/photo-1632633446780-a017032d265a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNjkwNTR8MHwxfHJhbmRvbXx8fHx8fHx8fDE2MzQ4NDA4NjM&ixlib=rb-1.2.1&q=80&w=1080",
      small:
        "https://images.unsplash.com/photo-1632633446780-a017032d265a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNjkwNTR8MHwxfHJhbmRvbXx8fHx8fHx8fDE2MzQ4NDA4NjM&ixlib=rb-1.2.1&q=80&w=400",
      thumb:
        "https://images.unsplash.com/photo-1632633446780-a017032d265a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNjkwNTR8MHwxfHJhbmRvbXx8fHx8fHx8fDE2MzQ4NDA4NjM&ixlib=rb-1.2.1&q=80&w=200",
    },
  };

  const {
    auth: { user },
  } = state;

  const [activeTab, setActiveTab] = useState(eventModalTab.CREATE);
  const [invitedUsers, setInvitedUsers] = useState([]);
  const [invitationMsg, setInvitationMsg] = useState("");
  const [isSendInvitationConfirm, setIsSendInvitationConfirm] = useState(false);

  const cancelButtonRef = useRef(null);
  const [cover, setCover] = useState(null);
  const [coverOpen, setCoverOpen] = useState(false);
  const [coverLoading, setCoverLoading] = useState(false);
  const [coverFile, setCoverFile] = useState(null);

  React.useEffect(() => {
    if (isOpen && !eventData?.cover) {
      getRandomCover();
    }
  }, [isOpen, eventData?.cover]);

  const getRandomCover = async () => {
    setCoverOpen(false);
    setCoverLoading(true);
    await getRandomPicture(user?.token)
      .then((res) => {
        setCover(res.data);
      })
      .catch((error) => {
        setCover(coverImage);
      })
      .finally(() => {
        setCoverLoading(false);
      });
  };

  return (
    <>
      <Transition.Root show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-10 inset-0 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={setIsOpen}
        >
          <div className="flex md:items-end items-start justify-center md:min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 z-30">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-overlay bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white dark:bg-navyGray rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle font-ubuntu w-450px">
                <div className="bg-white dark:bg-navyGray p-4 ">
                  <div className="flex justify-between items-center">
                    <div className="flex flex-row justify-start items-center">
                      {coverOpen ? (
                        <span
                          className="bg-frescoWhite rounded-full p-1 cursor-pointer text-gray-600 mr-2"
                          onClick={() => {
                            setCoverOpen(false);
                          }}
                        >
                          <Back />
                        </span>
                      ) : undefined}
                      <p className="font-medium text-lg text-black dark:text-frescoWhite">
                        {coverOpen ? "Change Cover" : "Create Event"}
                      </p>
                    </div>

                    <span
                      className="bg-frescoWhite p-9px rounded-full cursor-pointer"
                      onClick={() => {
                        setCoverOpen(false);
                        setIsOpen(false);
                      }}
                    >
                      <Close />
                    </span>
                  </div>
                </div>
                {coverOpen && (
                  <BannerPicker
                    setCover={setCover}
                    setCoverLoading={setCoverLoading}
                    setCoverOpen={setCoverOpen}
                    setCoverFile={setCoverFile}
                  />
                )}
                <div
                  className={`md:max-h-[80vh] max-h-[70vh] overflow-auto custom-scrollbar transform transition-all  ${
                    coverOpen ? "hidden" : "visible"
                  }`}
                >
                  <div className="wrapper dark:border-matteGray border-b border-frescoWhite">
                    <nav className="py-2.5">
                      <input
                        type="radio"
                        name="tab"
                        id="event"
                        checked={activeTab === eventModalTab.CREATE}
                        className="hidden"
                      />
                      <input
                        type="radio"
                        name="tab"
                        id="invite"
                        checked={activeTab === eventModalTab.INVITETAB}
                        className="hidden"
                      />
                      <label
                        htmlFor="event"
                        className="event"
                        onClick={() => {
                          setActiveTab(eventModalTab.CREATE);
                        }}
                      >
                        <span className="dark:!text-white text-xs font-ubuntu uppercase !text-black font-medium text-center block w-full">
                          General
                        </span>
                      </label>
                      <label
                        htmlFor="invite"
                        className="invite"
                        onClick={() => {
                          setActiveTab(eventModalTab.INVITETAB);
                        }}
                      >
                        <span className="dark:!text-white text-xs font-ubuntu uppercase !text-black font-medium text-center block w-full">
                          Invite
                        </span>
                      </label>
                      <div className="event-tab border-b-2 border-primary"></div>
                    </nav>
                  </div>

                  <div className="transform transition-all">
                    <div
                      className={` ${
                        activeTab === eventModalTab.CREATE
                          ? "visible"
                          : "hidden"
                      }`}
                    >
                      <EventSection
                        setIsOpen={setIsOpen}
                        roomId={roomId}
                        roomCallMaxParticipants={roomCallMaxParticipants}
                        setCoverOpen={setCoverOpen}
                        cover={cover}
                        eventData={eventData}
                        coverLoading={coverLoading}
                        coverFile={coverFile}
                        setCoverFile={setCoverFile}
                        setCover={setCover}
                        invitedUsers={invitedUsers}
                        invitationMsg={invitationMsg}
                      />
                    </div>
                    <div
                      className={` ${
                        activeTab === eventModalTab.INVITETAB
                          ? "visible"
                          : "hidden"
                      }`}
                    >
                      <InviteSection
                        isOpen={isOpen}
                        roomId={roomId}
                        invitedUsers={invitedUsers}
                        setInvitedUsers={setInvitedUsers}
                        invitationMsg={invitationMsg}
                        setInvitationMsg={setInvitationMsg}
                      />
                    </div>
                  </div>
                  {activeTab === eventModalTab.INVITETAB && (
                    <div className="flex px-6 pb-3 flex-row items-center justify-end space-x-2">
                      {isSendInvitationConfirm ? (
                        <p className="text-sm font-normal text-darkNight dark:text-frescoWhite">
                          Invitation will be send along with event creation
                        </p>
                      ) : (
                        <Button
                          size="vibhut-sm"
                          variant="vibhut-primary"
                          onClick={() => {
                            setActiveTab(eventModalTab.CREATE);
                            setIsSendInvitationConfirm(true);
                          }}
                        >
                          Invite
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}
